import type { CatalogSupplierRow } from '../catalog/types';

export const TEMPLATE_HELP_PATH = '/store/ayuda/plantilla';

export const TEMPLATE_CSV_PATH = '/store-suppliers/plantilla-proveedor-aipeces.csv';

const HEADER = 'external_id,nombre,marca,referencia,categoria,descripcion_corta,precio,coste,moneda,disponibilidad,unidades,gtin,foto,fotos,id_variante,sku_variante,talla,longitud,color,precio_variante,disponibilidad_variante,unidades_variante,ean_variante,foto_variante,categoria_ruta,ficha_tecnica,nombre_talla,nombre_longitud,nombre_color,seo_slug';

/** Caña con dos longitudes. La fila EXAMPLE de la plantilla vacía no entra. */
export const ROD_EXAMPLE = [
    HEADER,
    'CANA-01,Caña de surf,Cinnetic,CX-01,Cañas,Dos longitudes,89.00,40.00,EUR,en_stock,,,cana.jpg,,210,CX-210,,2.10 m,,89.00,en_stock,3,,cana-210.jpg,Cañas > Spinning,Acción: MH | Potencia: 20-80 g,,Acción,,cana-surf-210',
    'CANA-01,Caña de surf,Cinnetic,CX-01,Cañas,Dos longitudes,99.00,45.00,EUR,en_stock,,,cana.jpg,,240,CX-240,,2.40 m,,99.00,en_stock,2,,cana-240.jpg,,,,Acción,,',
].join('\n');

/** Señuelo sin variantes: las columnas de variante se dejan vacías. */
export const LURE_EXAMPLE = [
    HEADER,
    'SABA-01,Saba 11 g,Cinnetic,S11,Señuelos,Minnow,11.00,6.00,EUR,en_stock,20,,saba.jpg,,,,,,,,,,,,,,,,,',
].join('\n');

export const TEMPLATE_COLUMNS: { name: string; meaning: string }[] = [
    { name: 'external_id', meaning: 'Identidad del producto en el proveedor. Se repite en cada variante.' },
    { name: 'nombre', meaning: 'Nombre. Si la ficha ya se editó en el Portal, una segunda subida no lo pisa.' },
    { name: 'marca', meaning: 'Fabricante. Tampoco se pisa si ya está editada en el Portal.' },
    { name: 'referencia', meaning: 'Referencia del fabricante.' },
    { name: 'categoria', meaning: 'Categoría del proveedor, en texto.' },
    { name: 'descripcion_corta', meaning: 'Texto breve. El Portal conserva el texto ya editado.' },
    { name: 'precio', meaning: 'Precio de venta. En una variante, el de esa fila puede ir en precio_variante.' },
    { name: 'coste', meaning: 'Coste. Vacío si no se conoce.' },
    { name: 'moneda', meaning: 'EUR si se deja vacía.' },
    { name: 'disponibilidad', meaning: 'en_stock, agotado, bajo_pedido o vacío.' },
    { name: 'unidades', meaning: 'Stock del producto. Vacío es desconocido. 0 es agotado.' },
    { name: 'gtin', meaning: 'Código de barras del producto, si hay uno solo.' },
    { name: 'foto', meaning: 'Nombre del archivo dentro del ZIP. No es una URL.' },
    { name: 'fotos', meaning: 'Más archivos, separados por |.' },
    { name: 'id_variante', meaning: 'Identidad de la variante. Vacío si el producto no tiene variantes.' },
    { name: 'sku_variante', meaning: 'SKU de esa variante.' },
    { name: 'talla', meaning: 'Selector de talla, si el producto la tiene.' },
    { name: 'longitud', meaning: 'Selector de longitud, por ejemplo 2.10 m y 2.40 m.' },
    { name: 'color', meaning: 'Selector de color.' },
    { name: 'precio_variante', meaning: 'Precio de esa variante. Si está vacío, se usa el precio del producto.' },
    { name: 'disponibilidad_variante', meaning: 'en_stock, agotado, bajo_pedido o vacío.' },
    { name: 'unidades_variante', meaning: 'Se conserva en el archivo. La tienda aplica las unidades del producto.' },
    { name: 'ean_variante', meaning: 'Se conserva en el archivo. No sale como selector.' },
    { name: 'foto_variante', meaning: 'Archivo del ZIP para esa variante.' },
    { name: 'categoria_ruta', meaning: 'Ruta de la categoría, por ejemplo Cañas > Spinning. Solo entra al crear la ficha. Una sincronización posterior no la cambia.' },
    { name: 'ficha_tecnica', meaning: 'Pares clave: valor separados por |. Entra al crear y en sincronizaciones posteriores, hasta que la ficha técnica se edite en el Portal.' },
    { name: 'nombre_talla', meaning: 'Nombre del selector de talla. Si es Acción y talla es MH, la ficha y el carrito dicen Acción: MH. Vacío, la clave sigue siendo talla.' },
    { name: 'nombre_longitud', meaning: 'Nombre del selector de longitud. Vacío, la clave sigue siendo longitud.' },
    { name: 'nombre_color', meaning: 'Nombre del selector de color. Vacío, la clave sigue siendo color.' },
    { name: 'seo_slug', meaning: 'Dirección pública, solo al crear la ficha. Vacío, se usa external_id. Una sincronización posterior no la cambia. Para cambiarla después, Importar fichas con nuevo_seo_slug.' },
];

export function isFileTemplateSupplier(supplier: Pick<CatalogSupplierRow, 'slug' | 'connectorType' | 'feedConfig'>): boolean {
    if (supplier.slug === 'jlc' || supplier.slug === 'onnautic') return false;
    if (supplier.connectorType !== 'file') return false;
    const config = supplier.feedConfig;
    return Boolean(config && config.standard === 'aipeces_csv');
}
